import styled, { css } from 'styled-components'
import {
  OUTLINE_COLOR,
  GREY_BACKGROUND,
  PRIMARY_DARK_COLOR,
  SELECTED_ITEM_BG_COLOR,
} from '@CSSVars/colors'

const titleLeftIconCss = css`
  justify-content: flex-start;
  padding-right: 24px;
`
const SIZE = {
  medium: 36,
  large: 48,
}
export const _Container = styled.button`
  padding: 15px;
  position: static;

  height: ${({ size }) => SIZE[size] || 36}px;
  width: 100%;
  border: 1px solid ${OUTLINE_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;
  > svg {
    position: absolute;
    top: 25px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 10px;
  }

  background: ${({ showDropdown }) => (showDropdown ? GREY_BACKGROUND : 'inherit')};

  ${(hasLeftIcon) => (hasLeftIcon && titleLeftIconCss)}
  &:hover {
    cursor: pointer;
  }
`

export const _DropdownBox = styled.div`
  position: absolute;
  top:  48px;
  z-index: 10000;
  left: 0;
  width:100%;
  background: white;
  padding: 15px;
  border: 1px solid ${OUTLINE_COLOR};
  border-top: none;
  border-radius: 10px;
`

export const _TitleBox = styled.div`
  display: flex;
  align-items: center;
`

export const _BlurBg = styled.div`
  width: 100%;
  height: 500px;
  position: absolute;
  background: white;
  opacity: 0.9;
  left: 0;
  top: 100%;
  z-index: 2000;
`

export const _TitleLeftIcon = styled.div`
  padding-right: 16px;
`
export const _MenuBtn = styled.button`
  &:hover {
    cursor: pointer;
  }
  border: none;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
`
export const _BtnContainer = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  padding: 0px 40px !important;
  margin-bottom: 20px !important;
  button:last-child {
    color: ${PRIMARY_DARK_COLOR};
    :active {
      color:${SELECTED_ITEM_BG_COLOR};
    }
  }
`
